import React from 'react';
import { Container, Typography, Box, Grid } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

export default function PermissionInfoPage() {
    return (
        <Grid item xs={12} md={8} lg={9} className="card-content update-profile-card-content">
            <Container
                maxWidth="md"
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    height: '100%',
                    width: '100%'
                }}
            >
                <Box mb={2}>
                    <LockIcon style={{ fontSize: 60, color: '#3f51b5' }} />
                </Box>
                <Typography variant="h6" component="h6">
                    You do not have the permission to view or edit the Company details page.
                </Typography>
                <Typography variant="h6" component="h6">
                    Please contact your company administrator.
                </Typography>
            </Container>
        </Grid>
    );
}
